import { render, staticRenderFns } from "./AdminUtilityPendingTx.vue?vue&type=template&id=f6bc08ca"
import script from "./AdminUtilityPendingTx.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityPendingTx.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports